import React from 'react';
import MakeBuyAnalysis from '../components/production/makeorbuy/MakeBuyAnalysis';

const MakeBuyAnalysisPage = () => {
    return <MakeBuyAnalysis />;
};

export default MakeBuyAnalysisPage;
